<template>
    <div>
        <Slider></Slider>
        <Selling :cms-data="cmsDatas" :start-selling="startSelling"></Selling>
        <Cash :cms-data="cmsDatas" :data-feature="dataFeature"></Cash>
        <SellingMethod 
        :cms-data="cmsDatas" 
        :cms-sellbycat="sellellByCategory" 
        ></SellingMethod>
        <CustomerExperience 
        :best-review="bestReview" 
        :cms-data="cmsDatas" 
        ></CustomerExperience>
        <WhyUs 
        :cms-data="cmsDatas" 
        :cms-whyuseus="whyUseUs"
        ></WhyUs>
    </div>
</template>

<script>
import Slider from './home/Slider';
import Selling from './home/Selling';
import Cash from './home/Cash';
import SellingMethod from './home/SellingMethod';
import CustomerExperience from './home/CustomerExperience';
import WhyUs from './home/WhyUs';
import mixin from "../mixin";
import {setHomeScript} from "../helpers.js"
export default {
    name: "HomePage",
    mixins: [mixin],
    components: {
        Slider,
        Selling,
        Cash,
        SellingMethod,
        CustomerExperience,
        WhyUs 
    },
    data() {
        return {
            cmsDatas: [],
            whyUseUs: [],
            bestReview: [],
            dataFeature: [],
            startSelling: [],
            sellellByCategory: [],
        }
    },
    created() {
        this.fetchHomePageCMS();
    },
    mounted() {
        if (this.$route.path === '/') setHomeScript()
    }
    ,
    methods:{
        fetchHomePageCMS: function() {
            this.getHomePageCMS().then(response => {
                this.cmsDatas = response.data;
                this.whyUseUs = response.whyUseUs;
                this.bestReview = response.bestReview;
                this.dataFeature = response.dataFeature;
                this.startSelling = response.startSelling;
                this.sellellByCategory = response.sellellByCategory;
            });
        }
    }
}
</script>
